<template>
  <div class="empty_container">
    <div class="empty">
    </div>
    <div class="text"
         v-if="showText">暂无内容</div>
  </div>
</template>
<script>
  export default {
    name: "Empty",
    props: {
      showText: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        flag: false
      }
    },
    methods: {}
  }
</script>
<style lang="scss">
  .empty_container {
    padding: 60px 0 0;
    .text {
      text-align: center;
      padding: 40px 20px;
    }
    .empty {
      background-image: url(../assets/img/empty.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      height: 140px;
      margin: 0 auto 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Empty.vue